import {ModuleComponent} from "../../js/module-component";
import {readCookie} from "../../js/cookies";
import {createCookie} from "../../js/cookies";

export class ModCookies extends ModuleComponent{
    ready() {
        super.ready();
        let  cookieN = "cookiesok";
        let  cookieV = "ok";

        let cookie= readCookie(cookieN);
        this.$cookies = this.$root;


        if (cookie != cookieV) {
            this.$cookies.css("display", "block");
        }
        this.$cookies.toggle(cookie !== cookieV);

        this.$root.find(this.scope + "__accept-all").click(
            (ev) => {
                ev.preventDefault();
                createCookie(cookieN,cookieV, 365);
                this.$cookies.css("display", "none");
            }
        );

        this.$root.find(this.scope + '__confirm-config').click(
            (ev) => {
                ev.preventDefault();
                createCookie(cookieN, cookieV, 365);
                this.$cookies.css("display", "none");
            }
        );

        this.$root.find(this.scope + '__configure').click(
            (ev) => {
                ev.preventDefault();
                this.$cookies.find(this.scope + "__config").toggle();
            }
        );

        this.$root.find(this.scope + '__cancel').click(
            (ev) => {
                ev.preventDefault();
                createCookie(cookieN,cookieV, 365);
                this.$cookies.css("display", "none");
            }
        );

        this.$root.find(this.scope + '__button-toggle').click(
            (ev) => {
                ev.preventDefault();
                let toggleElemtId = $(ev.currentTarget).data("toggle-elem-id");
                this.findMember("cookie-details[data-toggle-elem-id='"+toggleElemtId+"']").toggle();
            }
        );

        this.$root.find(this.scope + '__close').click(
            (ev) => {
                ev.preventDefault();
                this.$cookies.find(this.scope + "__config").toggle();
            }
        );


        this.$root.find(this.scope + "__cookie-toggle").click((ev) => {
            const $button = $(ev.currentTarget);
            const targetId = $button.data("target");
            const $details = this.$cookies.find(`#${targetId}`);
            $button.toggleClass("active");

            if ($details.css("display") === "block") {
                $details.css("display", "none");
            } else {
                $details.css("display", "block");
            }
        });

        // Funcionalidad para toggles
        this.$root.find(this.scope + "__switch").click((ev) => {
            const $switch = $(ev.currentTarget);
            $switch.toggleClass("active");
        });

    }
}